<template>
  <div class="columns">
    <div class="column is-6">
      <table class="table is-bordered is-fullwidth">
        <thead>
          <tr>
            <th width="40%">Id</th>
            <th width="40%">Nombre</th>
            <th width="20%">Disponible</th>
          </tr>
        </thead>
        <tbody>
          <grilla-item
            v-for="(fila, index) in datos"
            :key="`fila-${index}`"
            :item="fila"
            :seleccionado="itemSeleccionado.id"
            @seleccionar="seleccionarItemHandle"
          />
          <tr v-if="datos.length === 0">
            <td colspan="3">No hay usuarios disponibles!</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="column is-6">
      <detalle-usuario
        v-if="hayItemSeleccionado"
        :key="`detalle-${itemSeleccionado.id}`"
        :usuario="itemSeleccionado"
      />
    </div>
  </div>
</template>

<script>
import GrillaItem from '@/components/controlUsuarios/GrillaItem.vue'
import DetalleUsuario from '@/components/controlUsuarios/DetalleUsuario.vue'

export default {
  name: 'Grilla',
  components: {
    GrillaItem,
    DetalleUsuario
  },
  props: {
    datos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      itemSeleccionado: {},
      hayItemSeleccionado: false
    }
  },
  watch: {
    datos() {
      const actual = this.itemSeleccionado
      const nuevo = this.datos.filter((item) => item.id === actual.id)[0]
      if (nuevo) {
        this.itemSeleccionado = nuevo
      }
    }
  },
  methods: {
    seleccionarItemHandle(item) {
      if (this.itemSeleccionado.id !== item.id) {
        this.itemSeleccionado = item
      }
      this.hayItemSeleccionado = true
    }
  }
}
</script>
